module.exports = __webpack_public_path__ + "static/media/whatsapp_green.9c43962f.svg";